module.exports = __webpack_public_path__ + "img/result-bg-hen.59cfbf5b.png";